import React from "react";
import { Button, SxProps } from "@mui/material";
import { Theme } from "@emotion/react";

interface ExportButtonProps {
  label: string;
  iconSrc?: string;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

/**
 * ExportButton component renders a button with an icon and label.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.label - The text label to display on the button.
 * @param {string} [props.iconSrc="/img/user/file.svg"] - The source URL of the icon image.
 * @param {function} props.onClick - The callback function to handle the button click event.
 * @param {SxProps<Theme>} props.sx - The MUI sx prop for styling.
 *
 * @returns {Element} The rendered ExportButton component.
 */
function ExportButton({
  label,
  iconSrc = "/img/user/file.svg",
  sx = {},
  onClick,
}: ExportButtonProps) {
  return (
    <Button
      variant="outlined"
      startIcon={<img src={iconSrc} width="23px" height="23px" alt="icon" />}
      sx={{
        border: "1px solid var(--gray-250)",
        height: { xs: "44px", md: "50px" },
        width: { xs: "140px", md: "180px" },
        fontSize: { xs: 18, lg: 23 },
        color: "var(--gray-700)",
        fontWeight: "medium",
        boxShadow: "var(--shadow)",
        ...sx,
      }}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}

export default ExportButton;
